import React from "react";
import Funnel, {
  Title,
  Margin,
  Export,
  Tooltip,
  Item,
  Border,
  Label,
} from "devextreme-react/funnel";
import CustomStore from "devextreme/data/custom_store";
import { api_path } from "../../shared.js"; // << path ของ API
import Box from "@mui/material/Box";
export default function SalesPipelineComponent({ userId,empCode,salesId,salesTeam ,salesRole,onStageClick ,page}) {
  //const url = `${api_path}/customer/get-customerStageSummary.php?userId=${userId}`;
  const url = `${api_path}/customer/get-customerStageSummary.php?userId=${userId}&empcode=${empCode}&salesId=${salesId}&salesTeam=${salesTeam}&salesRole=${salesRole}&page=${page}`;
  const dataSource = new CustomStore({
    key: "argument",
    load: () => {
      return fetch(url)
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            return data.map((item) => {
              let color = "#999";
              switch (item.argument.toLowerCase()) {
                case "lead":
                  color = "#4da6ff";
                  break;
                case "in contact":
                  color = "#17a2b8";
                  break;
                case "sales visit":
                  color = "#40c057";
                  break;
                case "quotation sent":
                  color = "#ff9800";
                  break;
                case "negotiation":
                  color = "#fd7e14";
                  break;
                case "closed - won":
                  color = "#198754";
                  break;
                case "closed - lost":
                  color = "#c92a2a";
                  break;
              }
              return { ...item, color };
            });
          }
          return [];
        })
        .catch(() => []);
    },
  });

  // const dataSource = new CustomStore({
  //   key: "argument", // ให้ argument เป็น key
  //   load: () => {
  //     return fetch(url)
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (Array.isArray(data)) {
  //           return data;
  //         } else {
  //           console.error("Invalid data:", data);
  //           return [];
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Load error:", err);
  //         return [];
  //       });
  //   },
  // });

  const formatLabel = (arg) => `${arg.item.argument} - ${arg.percentText}`;

  return (
    <div className="p-4 bg-white shadow rounded-2xl">
      <h5 className="font-semibold mb-2">Customer Stage</h5>
      <Box sx={{ maxHeight: 500, overflow: "auto" }}>
        <Funnel
          id="funnel"
          dataSource={dataSource}
          argumentField="argument"
          valueField="value"
          colorField="color" // 👈 ใช้สีจาก dataset
          paletteExtensionMode="useDataSourceColors"
          minPointSize={1}
          height={500}
          minSize={0.05}
          onItemClick={(e) => {
            if (onStageClick) {
              onStageClick(e.item.argument);
            }
          }}
        >
          <Tooltip enabled={true} format="fixedPoint" />
          <Item>
            <Border visible={true} />
          </Item>
          <Label
            visible={true}
            position="columns"
            backgroundColor="none"
            // customizeText={(arg) =>
            //   `${arg.item.argument} - ${arg.percentText}`
            // }
            font={{ size: 14, weight: "bold" }}
          />
        </Funnel>
      </Box>
    </div>
  );
}
